import React from "react";
import CheckIcon from "/Images/cekidot.svg"; // Checklist icon
import DeployImage from "/Images/custodyassetsnew1.svg"; // Gambar deployment

import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Ikon panah dari Material UI
import { useMediaQuery } from "@mui/material";

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query untuk layar mobile
  const isMobile2 = useMediaQuery("(max-width: 400px)"); // Media query untuk layar sangat kecil

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row", // Kolom untuk mobile, row untuk desktop
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E0DCD9",
      padding: isMobile2 ? "30px 10px" : isMobile ? "50px 20px" : "100px", // Padding lebih kecil untuk isMobile2
      borderRadius: "10px",
      textAlign: "left",
    },
    textContainer: {
      paddingRight: isMobile ? "0" : "20px", // Hilangkan padding untuk mobile
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start", // Pastikan konten selalu rata kiri
      width: isMobile ? "100%" : "45%", // Full width di mobile
      marginBottom: isMobile ? "20px" : "0",
    },
    imageContainer: {
      flex: 1,
      display: "flex",
      justifyContent: "center", // Pusatkan gambar di mobile
      alignItems: "center",
      width: isMobile ? "100%" : "50%", // Full width di mobile
      marginBottom: isMobile ? "20px" : "0",
    },
    image: {
      width: isMobile2 ? "70%" : isMobile ? "80%" : "574px", // Ukuran lebih kecil untuk isMobile2
      maxWidth: isMobile? "400px" :"574px",
      borderRadius: "10px",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile2 ? "15px" : isMobile ? "20px" : "30px", // Ukuran font lebih kecil untuk isMobile2
      fontWeight: "600",
      marginBottom: "20px",
      width: "420px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      marginBottom: "20px",
      justifyContent: "flex-start", // Rata kiri pada semua ukuran layar
    },
    listIcon: {
      height: isMobile2 ? "12px" : isMobile ? "15px" : "20px", // Ukuran ikon lebih kecil untuk isMobile2
      marginTop: "4px",
    },
    listTitle: {
      fontWeight: "600",
      fontSize: isMobile2 ? "0.75rem" : isMobile ? "0.875rem" : "1rem", // Font lebih kecil untuk isMobile2
      color: "#636363",
      marginBottom: "4px",
    },
    listDescription: {
      fontSize: isMobile2 ? "0.75rem" : isMobile ? "0.875rem" : "1rem", // Font lebih kecil untuk isMobile2
      color: "#6D6D6D",
      lineHeight: "1.5",
      margin: 0,
    },
    arrow: {
      marginLeft: "10px",
      backgroundColor: "#2D669B",
      borderRadius: "50%",
      padding: "5px",
      color: "#F4E37B",
    },
  };

  return (
    <div style={styles.container}>
      {/* Gambar ditempatkan di atas konten pada mobile */}
      {!isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Patent-pending HSM and  
          MPC technology
        </h2>
        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>Defense In-depth Security</span>
            <p style={styles.listDescription}>
              Hardware + software + fraud detection. Secured by HSM FIPS 140-2
              Level 3
            </p>
          </div>
        </div>

        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>Large Choice of Use Cases</span>
            <p style={styles.listDescription}>
              Secure wallet infrastructure, asset servicing for tokenized
              securities
            </p>
          </div>
        </div>

        <div style={styles.listItem}>
          <img src={CheckIcon} alt="Check" style={styles.listIcon} />
          <div>
            <span style={styles.listTitle}>
              Rapid integration, flexible deployment
            </span>
            <p style={styles.listDescription}>
              10 days of integration. On premise, SaaS, or hybrid
            </p>
          </div>
        </div>
      </div>
      {/* Gambar ditempatkan di samping teks pada desktop */}
      {isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
    </div>
  );
};

export default DeploymentSection;
